import React, { Component } from 'react';
import CartLineItem from './CartLineItem';
import ScrollLock, { TouchScrollable } from 'react-scrolllock';
import FreeShippingThreshold from './FreeShippingThreshold';

const CartList = ({ data, setShowDrawer }) => {
  const { items, item_count, total_price } = data;
  
  const ctx = window.theme_app;
  let show_free_shipping_threshold = ctx.getState().show_free_shipping_threshold;
  // console.log(free_shipping_exclude_types)


  if (items?.length < 1) {
    return (
      <div className="Loop Loop--minicart">
        <div className="empty-cart">You don't have any items in your bag.</div>
      </div>
    );
  } else {
    return (
      <>
        <TouchScrollable>
          <div className="Loop Loop--minicart drawer-scroll">
            {items.map((item, index) => {
              if (!item.properties?._io_parent_order_group) {
                return <CartLineItem product={item} key={`${item.id}-${item.key}`} />;
              }
            })}
          </div>
        </TouchScrollable>
        <div>
          {show_free_shipping_threshold && (
            <FreeShippingThreshold items={items} />
          )}
          <div className="MiniCart__totals">
            {data.total_discount > 0 && (
              <div className="discounts">
                <span className="label">Discounts</span>
                <span className="discount">${(data.total_discount / 100).toFixed(2)}</span>
              </div>
            )}
            <div className="subtotal">
              <span className="label">Subtotal</span>
              <span className="total">${(data.total_price / 100).toFixed(2)}</span>
            </div>
          </div>
        </div>
        {/* <div className="MiniCart__notices">
          <div className="shipping">Shipping and Taxes calculated at checkout</div>
          <div className="international-shipping">Notice: International Shipments may be subject to delays due to COVID-19.</div>
        </div> */}
        <form action="/cart" method="post" noValidate className="MiniCart__form">
          {/* <button type="submit" name="checkout" className="Button" data-style="solid dark">
            Checkout
          </button> */}
          <a href="/cart" className="Button" data-style="solid blue">
            View Cart
          </a>
        </form>
      </>
    );
  }
};
export default CartList;
